import React from 'react';

/**
 * Loading Component - Component hiển thị trạng thái loading
 */
interface LoadingProps {
    size?: 'small' | 'medium' | 'large';
    text?: string;
    overlay?: boolean;
    className?: string;
}

const Loading: React.FC<LoadingProps> = ({
    size = 'medium',
    text = 'Đang tải...',
    overlay = false,
    className = ''
}) => {
    const baseClass = 'loading';
    const sizeClass = `loading-${size}`;
    const overlayClass = overlay ? 'loading-overlay' : '';
    const classes = [baseClass, sizeClass, overlayClass, className].filter(Boolean).join(' ');

    return (
        <div className={classes}>
            <div className="loading-spinner">
                <div className="spinner-circle"></div>
            </div>
            {text && <div className="loading-text">{text}</div>}
        </div>
    );
};

export default Loading;
